import { Toaster as SonnerToaster } from 'sonner';
import { useTheme } from '@/components/theme-provider';

export function Toaster(props) {
  const { theme } = useTheme();
  return (
    <SonnerToaster
      theme={theme}
      richColors
      closeButton
      position="bottom-right"
      duration={2500}
      toastOptions={{
        classNames: {
          toast: 'group toast group-[.toaster]:bg-card group-[.toaster]:text-card-foreground group-[.toaster]:border-border group-[.toaster]:shadow-elev-2',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
}

export { toast } from 'sonner';
